import type { AxiosError } from 'axios'

import type { Usuario } from '@/models/usuario'
import { servicoBase } from '@/services/servico-base'

export async function buscarEu(): Promise<Partial<Usuario> | AxiosError> {
  try {
    const { data } = await servicoBase.get<Usuario>('/v1/usuarios/eu')
    return data
  } catch (error) {
    return error as AxiosError
  }
}
